import React, { useEffect, useRef } from "react";
import { 
  FiSearch, 
  FiMoreVertical, 
  FiCheckCircle, 
  FiXCircle, 
  FiToggleLeft, 
  FiToggleRight,
  FiUser,
  FiCalendar,
  FiTag,
  FiClock,
  FiFileText,
  FiGrid,
  FiList,
  FiRefreshCw,
  FiEye,
  FiEdit2,
  FiTrash2,
  FiArrowUp,
  FiArrowDown,
  FiTrendingUp,
  FiTrendingDown,
  FiAlertCircle,
  FiHash,
  FiBookOpen,
  FiInfo,
  FiFilter
} from "react-icons/fi";
import { 
  MdOutlineSearch, 
  MdOutlineFilter,
  MdOutlineVisibility,
  MdOutlineEdit,
  MdOutlineDelete,
  MdOutlineCategory,
  MdOutlinePerson,
  MdOutlineCalendarToday,
  MdOutlineCheckCircle,
  MdOutlineCancel,
  MdOutlinePending,
  MdOutlineBook,
  MdOutlineDescription,
  MdOutlineInfo
} from "react-icons/md";
import { HiOutlineDotsVertical } from "react-icons/hi";
import ContentAction from "./ContentAction";
import ReactPaginate from "react-paginate";
import { CiSearch } from "react-icons/ci";
import moment from "moment";
import SortableHeader from "../../../components/SortableHeader";

const ContentTable = ({
  TbaleName,
  TbaleHeader,
  TbaleData,
  showMenu,
  viewAction,
  removeContent,
  isMenu,
  clickedUserId,
  total,
  size,
  handlePageClick,
  offset,
  setkeyword,
  keyword,
  handleFilter,
  setactive,
  handleSubmit,
  setAdminToggleData,
  currentSortKey,
  currentSortOrder,
  onSort
}) => {
  const ContentActionRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ContentActionRef.current &&
        !ContentActionRef.current.contains(event.target)
      ) {
        showMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  // Status badge component
  const StatusBadge = ({ isDisable }) => {
    if (!isDisable) {
      return (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full">
          <FiCheckCircle className="w-3.5 h-3.5 text-emerald-500" />
          Active
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-rose-700 bg-rose-50 border border-rose-200 rounded-full">
        <FiXCircle className="w-3.5 h-3.5 text-rose-500" />
        Inactive
      </span>
    );
  };

  // Admin status badge
  const AdminStatusBadge = ({ isDisabled }) => {
    if (!isDisabled) {
      return (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full">
          <FiCheckCircle className="w-3.5 h-3.5 text-emerald-500" />
          Approved
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-rose-700 bg-rose-50 border border-rose-200 rounded-full">
        <FiXCircle className="w-3.5 h-3.5 text-rose-500" />
        Rejected
      </span>
    );
  };

  // Helper function to truncate text
  const truncateText = (text, maxLength = 20) => {
    if (!text) return "N/A";
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  return (
    <div className="w-full">
      <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 p-4 md:p-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white">
          <div className="flex items-center gap-3">
            <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
              <FiBookOpen className="w-4 h-4 text-[#715EFE]" />
            </div>
            <div>
              <h2 className="text-base font-semibold text-gray-800">{TbaleName}</h2>
              <p className="text-xs text-gray-400 hidden sm:block">
                {TbaleData?.length || 0} courses
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
            {/* Search */}
            <div className="relative flex-1 sm:min-w-[180px]">
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search courses..."
                className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
                onChange={(e) => setkeyword(e.target.value)}
                value={keyword}
              />
            </div>

            {/* Filter */}
            <div className="relative min-w-[120px]">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FiFilter className="text-gray-400 w-4 h-4" />
              </div>
              <select
                onChange={(e) => setactive(e.target.value)}
                className="appearance-none w-full h-10 pl-9 pr-8 py-2 bg-white border border-gray-200 text-sm text-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
              >
                <option value={""}>All Status</option>
                <option value={"enable"}>Active</option>
                <option value={"disable"}>Inactive</option>
              </select>
              <FiClock className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50/80 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">
                {TbaleHeader.map((heading, index) => {
                  const headerIcons = {
                    '#': null,
                    'Course id': FiHash,
                    'Title': FiBookOpen,
                    'Uploaded By': FiUser,
                    'Status': FiCheckCircle,
                    'Admin Status': FiToggleLeft,
                    'Upload Date': FiCalendar,
                    'Action': null
                  };
                  const Icon = headerIcons[heading.label];
                  return (
                    <td key={index} className="px-3 md:px-4 py-3 whitespace-nowrap">
                      <SortableHeader
                        label={heading.label}
                        sortKey={heading.sortKey}
                        currentSortKey={currentSortKey}
                        currentSortOrder={currentSortOrder}
                        onSort={onSort}
                        icon={Icon}
                      />
                    </td>
                  );
                })}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {TbaleData && TbaleData?.length > 0 ? (
                TbaleData?.map((ele, index) => (
                  <tr
                    key={ele?.id || ele?._id || index}
                    className="hover:bg-gray-50/70 transition-colors duration-150 group"
                  >
                    <td className="px-3 md:px-4 py-3">
                      <span className="text-sm font-medium text-gray-400">
                        {offset + index + 1}
                      </span>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-2">
                        <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 flex items-center justify-center">
                          <FiHash className="w-3.5 h-3.5 text-[#715EFE]" />
                        </div>
                        <span className="text-xs font-mono text-gray-600">
                          {ele?._id ? `${ele._id.slice(0, 8)}...` : "N/A"}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 flex items-center justify-center">
                          <FiBookOpen className="w-3.5 h-3.5 text-[#715EFE]" />
                        </div>
                        <span 
                          className="text-sm font-medium text-gray-800 truncate max-w-[120px] md:max-w-[180px]" 
                          title={ele?.title || "N/A"}
                        >
                          {truncateText(ele?.title, 20)}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 flex items-center justify-center">
                          <span className="text-xs font-bold text-[#715EFE]">
                            {ele?.user?.fullName?.charAt(0)?.toUpperCase() || 'U'}
                          </span>
                        </div>
                        <span className="text-sm text-gray-700 truncate max-w-[80px]">
                          {ele?.user?.fullName || 'Unknown'}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <button
                        onClick={() => handleSubmit(ele)}
                        className={`px-2.5 py-1 text-xs font-medium rounded-full transition-all duration-200 ${
                          !ele?.isDisable 
                            ? 'text-emerald-700 bg-emerald-50 border border-emerald-200 hover:bg-emerald-100' 
                            : 'text-rose-700 bg-rose-50 border border-rose-200 hover:bg-rose-100'
                        }`}
                      >
                        {ele?.isDisable ? 'Inactive' : 'Active'}
                      </button>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <AdminStatusBadge isDisabled={ele?.isDisableByAdmin} />
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex flex-col">
                        <span className="text-sm text-gray-700 whitespace-nowrap">
                          {ele?.createdAt ? moment(ele.createdAt).format('MMM D, YYYY') : 'N/A'}
                        </span>
                        {ele?.createdAt && (
                          <span className="text-xs text-gray-400">
                            {moment(ele.createdAt).format('h:mm A')}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="relative">
                        <button
                          className="p-1.5 text-gray-400 hover:text-[#715EFE] hover:bg-[#715EFE]/10 rounded-lg transition-all duration-200"
                          onClick={() => showMenu(ele?._id)}
                        >
                          <HiOutlineDotsVertical className="w-4 h-4" />
                        </button>
                        <div
                          className={`absolute right-0 bg-white rounded-xl w-40 z-50 overflow-hidden animate-in fade-in zoom-in-95 duration-200
                          ${
                            TbaleData.length === 1
                              ? "top-full mt-1"
                              : index === TbaleData.length - 1
                                ? "bottom-full mb-2"
                                : "mt-1"
                          }`}
                        >
                          {isMenu && clickedUserId === ele?._id && (
                            <div ref={ContentActionRef}>
                              <ContentAction
                                element={ele}
                                removerContent={() => removeContent(ele)}
                                viewAction={() => viewAction(ele)}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={TbaleHeader.length} className="px-4 py-12 text-center">
                    <div className="flex flex-col items-center gap-3">
                      <div className="p-4 bg-gray-50 rounded-full">
                        <FiBookOpen className="w-10 h-10 text-gray-300" />
                      </div>
                      <p className="text-sm font-medium text-gray-500">No courses found</p>
                      <p className="text-xs text-gray-400">Try adjusting your search or filters</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {total > 10 && (
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-gray-100 bg-gray-50/50">
            <div className="text-sm text-gray-500">
              Showing {offset + 1} to {Math.min(offset + size, total)} of {total} entries
            </div>
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              breakClassName={"px-2 text-gray-400"}
              pageCount={Math.ceil(total / size)}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"flex items-center gap-1"}
              pageClassName={"px-2"}
              pageLinkClassName={"px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"}
              previousClassName={"px-2"}
              previousLinkClassName={"px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"}
              nextClassName={"px-2"}
              nextLinkClassName={"px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"}
              activeClassName={"bg-[#715EFE] text-white rounded-md"}
              activeLinkClassName={"bg-[#715EFE] text-white px-3 py-1 rounded-md"}
              disabledClassName={"opacity-50 cursor-not-allowed"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentTable;